import { SystemUnit } from '../../scratchpad/application/shared/model/flow.types';
import { UserPreferences, useGetUserPreference } from './preference.hooks';

export const useGetUnitOfMeasureSystem = (): SystemUnit => {
  const userSystemPreference = useGetUserPreference<SystemUnit>(
    UserPreferences.UNIT_OF_MEASURE,
    {
      // all user preferences are retrieved during hydration
      fetchPolicy: 'cache-first',
    }
  );

  return userSystemPreference?.value ?? SystemUnit.IMPERIAL;
};
